(function () {
  "use strict";

  var isProductPage = window.isProductPage === true;
  var isCartPage = false;

  function isThisCartPage() {
    return /\/cart(\?|$|\/?$)/.test(window.location.pathname);
  }

  isCartPage = isThisCartPage();

  function formatMoney(cents, currencyCodeEnabled) {
    var amount = cents / 100;
    var formattedAmount = amount.toFixed(2);
    var parts = formattedAmount.split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    formattedAmount = parts.join(".");
    return window.shop_currency + " " + formattedAmount;
  }

  function formatMoneyDrawer(cents) {
    try {
      var amount = (parseInt(cents || 0, 10) / 100).toFixed(2);
      var parts = amount.split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return window.shop_currency + " " + parts.join(".");
    } catch (e) {
      return window.shop_currency + " 0.00";
    }
  }

  function parseMoneyTextToCents(txt) {
    try {
      var m = (txt || "").match(/[\d'.,]+/);
      if (!m) return 0;
      var s = m[0].replace(/[']/g, "").replace(/,/g, "");
      return Math.round(parseFloat(s) * 100);
    } catch (e) {
      return 0;
    }
  }

  function saveDiscountPreference(discountTitle) {
    try {
      if (!discountTitle || discountTitle.trim() === "") {
        localStorage.setItem("activeDiscountTitle", "__no_discount__");
      } else {
        localStorage.setItem("activeDiscountTitle", discountTitle);
      }
    } catch (e) {
      console.error("[DEBUG] Error saving discount preference:", e);
    }
  }

  function getDiscountPreference() {
    try {
      var pref = localStorage.getItem("activeDiscountTitle");
      if (pref === "__no_discount__") {
        return "";
      }
      return pref || "";
    } catch (e) {
      console.error("[DEBUG] Error getting discount preference:", e);
      return "";
    }
  }

  function hasNoDiscountPreference() {
    try {
      return localStorage.getItem("activeDiscountTitle") === "__no_discount__";
    } catch (e) {
      console.error("[DEBUG] Error checking no-discount preference:", e);
      return false;
    }
  }

  function saveVariantDiscount(
    variantId,
    discountTitle,
    discountPercentage,
    buttonNumber
  ) {
    try {
      if (!variantId) {
        console.error("[DEBUG] saveVariantDiscount: No variantId provided");
        return;
      }
      var variantIdStr = String(variantId).trim();
      var variantDiscounts = {};
      var stored = localStorage.getItem("variantDiscounts");
      if (stored) {
        try {
          variantDiscounts = JSON.parse(stored);
        } catch (e) {
          console.error("[DEBUG] Error parsing stored variantDiscounts:", e);
          variantDiscounts = {};
        }
      }

      var resolvedButton = buttonNumber;
      if (resolvedButton === undefined || resolvedButton === null) {
        try {
          var lockedPref = localStorage.getItem("cartLockedDiscountPreference");
          if (lockedPref) {
            resolvedButton = parseInt(lockedPref, 10) || null;
          }
        } catch (e) {}
      }

      if (discountTitle === null) {
        variantDiscounts[variantIdStr] = null;
      } else if (!discountTitle || discountTitle.trim() === "") {
        delete variantDiscounts[variantIdStr];
      } else {
        variantDiscounts[variantIdStr] = {
          title: discountTitle,
          percentage: discountPercentage || 0,
          button: resolvedButton || null,
        };
      }
      localStorage.setItem(
        "variantDiscounts",
        JSON.stringify(variantDiscounts)
      );
    } catch (e) {
      console.error("[DEBUG] Error in saveVariantDiscount:", e);
    }
  }

  function markVariantNoDiscount(variantId) {
    try {
      if (!variantId) {
        console.error("[DEBUG] markVariantNoDiscount: No variantId provided");
        return;
      }
      var variantIdStr = String(variantId).trim();
      var variantDiscounts = {};
      var stored = localStorage.getItem("variantDiscounts");
      if (stored) {
        try {
          variantDiscounts = JSON.parse(stored);
        } catch (e) {
          variantDiscounts = {};
        }
      }
      variantDiscounts[variantIdStr] = null;
      localStorage.setItem(
        "variantDiscounts",
        JSON.stringify(variantDiscounts)
      );
      console.log("[DEBUG] Marked variant as no-discount:", variantIdStr);
    } catch (e) {
      console.error("[DEBUG] Error in markVariantNoDiscount:", e);
    }
  }

  function variantHasNoDiscount(variantId) {
    try {
      if (!variantId) {
        return false;
      }
      var variantIdStr = String(variantId).trim();
      var stored = localStorage.getItem("variantDiscounts");
      if (!stored) {
        return false;
      }
      var variantDiscounts = JSON.parse(stored);

      return (
        variantDiscounts.hasOwnProperty(variantIdStr) &&
        variantDiscounts[variantIdStr] === null
      );
    } catch (e) {
      console.error("[DEBUG] Error in variantHasNoDiscount:", e);
      return false;
    }
  }

  function getVariantDiscount(variantId) {
    try {
      var stored = localStorage.getItem("variantDiscounts");
      if (stored) {
        var variantDiscounts = JSON.parse(stored);
        var discount = variantDiscounts[variantId];
        if (discount) {
          return typeof discount === "string" ? discount : discount.title || "";
        }
      }
    } catch (e) {
      console.error("[DEBUG] Error getting variant discount:", e);
    }
    return "";
  }

  function getVariantDiscountData(variantId) {
    try {
      if (!variantId) {
        return null;
      }
      var variantIdStr = String(variantId).trim();
      var stored = localStorage.getItem("variantDiscounts");
      if (!stored) {
        return null;
      }
      var variantDiscounts = JSON.parse(stored);
      var discount = variantDiscounts[variantIdStr];
      if (discount && typeof discount === "object") {
        return discount;
      } else if (discount && typeof discount === "string") {
        return { title: discount, percentage: 0, button: null };
      }
    } catch (e) {
      console.error("[DEBUG] Error in getVariantDiscountData:", e);
    }
    return null;
  }

  function getAssemblyPreference() {
    try {
      var lockedPreference = localStorage.getItem(
        "cartLockedDiscountPreference"
      );
      if (lockedPreference) {
        var lockedButtonNumber = parseInt(lockedPreference, 10);
        return lockedButtonNumber;
      }

      var preference = localStorage.getItem("assemblyPreference");
      return preference ? parseInt(preference, 10) : null;
    } catch (e) {
      console.error("[BUTTON] Error getting assembly preference:", e);
      return null;
    }
  }

  function isAssemblyBySkyPergola() {
    return getAssemblyPreference() === 2;
  }

  function getButtonDiscountMapping() {
    try {
      var mapping = localStorage.getItem("buttonDiscountMapping");
      return mapping ? JSON.parse(mapping) : null;
    } catch (e) {
      console.error("[BUTTON] Error getting button discount mapping:", e);
      return null;
    }
  }

  function getDiscountTitleForButtonNumber(buttonNumber) {
    var mapping = getButtonDiscountMapping();
    if (!mapping) return null;
    if (buttonNumber === 1) return mapping.button1;
    if (buttonNumber === 2) return mapping.button2;
    return null;
  }

  function hasActiveDiscountForButton(buttonNumber) {
    var discountTitle = getDiscountTitleForButtonNumber(buttonNumber);
    return discountTitle !== null && discountTitle !== undefined;
  }

  function getCurrentButtonNumber() {
    try {
      var lockedPreference = localStorage.getItem(
        "cartLockedDiscountPreference"
      );
      if (lockedPreference) {
        return parseInt(lockedPreference, 10);
      }
      var assemblyPref = localStorage.getItem("assemblyPreference");
      if (assemblyPref) {
        return parseInt(assemblyPref, 10);
      }
      var activeButton = document.querySelector(".discount-button.active");
      if (activeButton) {
        if (activeButton.id === "discount-button-2") return 2;
        if (activeButton.id === "discount-button-1") return 1;
      }
      return 1;
    } catch (e) {
      return 1;
    }
  }

  function hasActiveDiscountForCurrentSelection() {
    return hasActiveDiscountForButton(getCurrentButtonNumber());
  }

  function shouldApplyDiscount() {
    var buttonNumber = getCurrentButtonNumber();
    var discountTitle = getDiscountTitleForButtonNumber(buttonNumber);
    return (
      discountTitle !== null &&
      discountTitle !== undefined &&
      discountTitle !== ""
    );
  }

  function showOriginalPrice() {
    var priceContainer = getPriceContainer();
    if (!priceContainer) return false;

    var dataPrice = priceContainer.getAttribute("data-variant-price");
    if (!dataPrice) return false;

    var variantPrice = parseInt(dataPrice, 10);
    var formattedPrice = formatMoney(variantPrice, true);

    var priceEl =
      priceContainer.querySelector(".price-list .price") ||
      priceContainer.querySelector(".price:not(.price--compare)");
    if (priceEl) {
      priceEl.textContent = formattedPrice;
    }

    var comparePriceEl = priceContainer.querySelector(".price--compare");
    var compareAtPrice = parseInt(priceContainer.getAttribute("data-compare-at-price") || "0");
    // Show compare price if native compare_at_price exists, hide otherwise
    if (comparePriceEl) {
      if (compareAtPrice && compareAtPrice > variantPrice) {
        comparePriceEl.style.display = "";
      } else {
        comparePriceEl.style.display = "none";
      }
    }

    var savingsEl = document.querySelector(".product-form-saving-price");
    if (savingsEl) {
      // Show savings from compare_at_price if it exists
      if (compareAtPrice && compareAtPrice > variantPrice) {
        var displaySavings = compareAtPrice - variantPrice;
        var formattedDisplaySavings = formatMoney(displaySavings, true);
        savingsEl.innerHTML = 'Spare: <span class="product-savings-amount">' + formattedDisplaySavings + '</span>';
        savingsEl.style.display = "block";
      } else {
        savingsEl.style.display = "none";
      }
    }

    var appliedDiscountEl = document.getElementById("applied-discount");
    if (appliedDiscountEl) {
      appliedDiscountEl.style.display = "none";
    }

    return true;
  }

  function getDiscountForButton(buttonNumber, discounts) {
    try {
      if (!discounts || !Array.isArray(discounts) || discounts.length === 0) {
        return null;
      }

      var discountsWithPercentages = discounts
        .map(function (discount) {
          var percentage = 0;
          var discountValue = discount.value;

          if (discountValue) {
            if (discountValue.value !== undefined) {
              var value = parseFloat(discountValue.value);
              if (discountValue.type === "percentage") {
                if (value <= 1) {
                  percentage = value * 100;
                } else {
                  percentage = value;
                }
              } else {
                percentage = value * 100;
              }
            } else if (typeof discountValue === "number") {
              percentage =
                discountValue <= 1 ? discountValue * 100 : discountValue;
            } else if (typeof discountValue === "string") {
              var parsed = parseFloat(discountValue);
              percentage = parsed <= 1 ? parsed * 100 : parsed;
            }
          }

          return {
            title: discount.title || "",
            percentage: percentage,
            discount: discount,
          };
        })
        .sort(function (a, b) {
          return b.percentage - a.percentage;
        });

      if (discountsWithPercentages.length === 0) {
        return null;
      }

      if (buttonNumber === 1) {
        return discountsWithPercentages[0];
      } else if (buttonNumber === 2) {
        return discountsWithPercentages.length >= 2
          ? discountsWithPercentages[1]
          : discountsWithPercentages[0];
      }

      return null;
    } catch (e) {
      console.error("[BUTTON] Error getting discount for button:", e);
      return null;
    }
  }

  function syncCartLocalStorage(cartData) {
    try {
      if (!cartData || !cartData.items) {
        console.log("[SYNC] No cart data provided");
        return;
      }

      var variantIdsInCart = [];
      cartData.items.forEach(function (item) {
        if (item.variant_id) {
          variantIdsInCart.push(String(item.variant_id));
        }
      });

      if (variantIdsInCart.length === 0) {
        localStorage.removeItem("variantDiscounts");
        localStorage.removeItem("variantRelationships");
        localStorage.removeItem("cartLockedDiscountPreference");
        console.log("[SYNC] Cart empty - cleared all discount localStorage");
        return;
      }

      var hasAnyDiscountedProduct = false;

      try {
        var variantDiscountsStr = localStorage.getItem("variantDiscounts");
        if (variantDiscountsStr) {
          var variantDiscounts = JSON.parse(variantDiscountsStr);
          var hasChanges = false;
          for (var variantId in variantDiscounts) {
            if (variantIdsInCart.indexOf(variantId) === -1) {
              delete variantDiscounts[variantId];
              hasChanges = true;
            } else {
              var discount = variantDiscounts[variantId];
              if (
                discount !== null &&
                discount &&
                (discount.title || discount.percentage > 0)
              ) {
                hasAnyDiscountedProduct = true;
              }
            }
          }
          if (hasChanges) {
            if (Object.keys(variantDiscounts).length === 0) {
              localStorage.removeItem("variantDiscounts");
            } else {
              localStorage.setItem(
                "variantDiscounts",
                JSON.stringify(variantDiscounts)
              );
            }
          }
        }
      } catch (e) {
        console.error("[SYNC] Error syncing variantDiscounts:", e);
      }

      try {
        var variantRelationshipsStr = localStorage.getItem(
          "variantRelationships"
        );
        if (variantRelationshipsStr) {
          var variantRelationships = JSON.parse(variantRelationshipsStr);
          var hasChanges = false;
          for (var mainVariantId in variantRelationships) {
            if (variantIdsInCart.indexOf(mainVariantId) === -1) {
              delete variantRelationships[mainVariantId];
              hasChanges = true;
            }
          }
          if (hasChanges) {
            if (Object.keys(variantRelationships).length === 0) {
              localStorage.removeItem("variantRelationships");
            } else {
              localStorage.setItem(
                "variantRelationships",
                JSON.stringify(variantRelationships)
              );
            }
          }
        }
      } catch (e) {
        console.error("[SYNC] Error syncing variantRelationships:", e);
      }

      if (!hasAnyDiscountedProduct) {
        var hadLockedPreference = localStorage.getItem(
          "cartLockedDiscountPreference"
        );
        if (hadLockedPreference) {
          localStorage.removeItem("cartLockedDiscountPreference");
          console.log(
            "[SYNC] No discounted products in cart - cleared cartLockedDiscountPreference"
          );
        }
      }

      console.log(
        "[SYNC] Cart localStorage synced. Has discounted products:",
        hasAnyDiscountedProduct
      );
    } catch (e) {
      console.error("[SYNC] Error in syncCartLocalStorage:", e);
    }
  }

  function cleanuplocalStorageForRemovedItems() {
    try {
      fetch("/cart.js")
        .then(function (response) {
          return response.json();
        })
        .then(function (cartData) {
          syncCartLocalStorage(cartData);
        })
        .catch(function (error) {
          console.error("[CLEANUP] Error fetching cart:", error);
        });
    } catch (e) {
      console.error("[CLEANUP] Error in cleanup function:", e);
    }
  }

  function findDiscountByTitle(discounts, title) {
    if (!discounts || !Array.isArray(discounts) || !title) {
      return null;
    }
    var titleStr = (title || "").trim();
    if (!titleStr) {
      return null;
    }
    var titles = titleStr
      .split(",")
      .map(function (t) {
        return t.trim();
      })
      .filter(function (t) {
        return t.length > 0;
      });
    if (titles.length === 0) {
      return null;
    }
    var exactMatches = [];
    var titlesLower = titles.map(function (t) {
      return t.toLowerCase();
    });
    discounts.forEach(function (d) {
      var discountTitle = (d.title || d.code || "").trim();
      var discountTitleLower = discountTitle.toLowerCase();
      for (var i = 0; i < titlesLower.length; i++) {
        if (discountTitleLower === titlesLower[i]) {
          exactMatches.push(d);
          break;
        }
      }
    });
    if (exactMatches.length === 0) {
      return null;
    }
    if (exactMatches.length === 1) {
      return exactMatches[0];
    }
    var bestMatch = exactMatches[0];
    var bestPercentage = bestMatch.percentage || 0;
    for (var i = 1; i < exactMatches.length; i++) {
      var candidatePercentage = exactMatches[i].percentage || 0;
      if (candidatePercentage > bestPercentage) {
        bestMatch = exactMatches[i];
        bestPercentage = candidatePercentage;
      }
    }
    return bestMatch;
  }

  function getActiveDiscountFromPage() {
    try {
      var activeButton = document.querySelector(".discount-button.active");
      if (activeButton) {
        var discountTitle =
          activeButton.getAttribute("data-discount-title") || "";
        if (discountTitle && discountTitle.trim() !== "") {
          return discountTitle.trim();
        }
      }
      return null;
    } catch (e) {
      console.error("[DEBUG] Error getting active discount from page:", e);
      return null;
    }
  }

  function getPriceContainer() {
    var selectors = [".price_list_wrapper"];
    for (var i = 0; i < selectors.length; i++) {
      var el = document.querySelector(selectors[i]);
      if (el) return el;
    }
    return null;
  }

  function getOriginalPrice() {
    var priceContainer = getPriceContainer();
    if (!priceContainer) return null;
    var variantPrice = priceContainer.getAttribute("data-variant-price");
    if (variantPrice) {
      return parseInt(variantPrice);
    }
    var comparePriceEl = priceContainer.querySelector(
      ".price--compare .amount"
    );
    var regularPriceEl = priceContainer.querySelector(".price .amount");

    if (!comparePriceEl) {
      console.error("No comparePriceEl or regularPriceEl found");
    }

    if (!regularPriceEl) {
      console.error("No regularPriceEl found");
    }

    var priceText =
      (comparePriceEl || regularPriceEl)?.textContent?.trim() || "";
    var priceMatch = priceText.match(/[\d'.,]+/);
    if (priceMatch) {
      var cleanPrice = priceMatch[0].replace(/[']/g, "").replace(",", ".");
      var price = parseFloat(cleanPrice) * 100;
      if (price && !isNaN(price)) {
        return price;
      }
    }
    try {
      var productJson = document.querySelector(
        '[type="application/json"][data-product-json]'
      )?.textContent;
      if (productJson) {
        var productData = JSON.parse(productJson);
        var variant =
          productData.variants?.find(function (v) {
            return v.available;
          }) || productData.variants?.[0];
        if (variant) {
          return parseInt(variant.price);
        }
      }
    } catch (e) {}
    return null;
  }

  function getVariantFromSelectedOptions() {
    try {
      var productJson = document.querySelector(
        '[type="application/json"][data-product-json]'
      )?.textContent;
      if (!productJson) {
        return null;
      }
      var productData = JSON.parse(productJson);

      var variants = productData.product?.variants || productData.variants;
      if (!variants || !Array.isArray(variants)) {
        return null;
      }

      var selectedOptions = [];

      var allSelectors = document.querySelectorAll(
        ".product-form__single-selector"
      );

      for (var i = 0; i < allSelectors.length; i++) {
        var selector = allSelectors[i];
        var isSelected = false;

        if (selector.type === "radio" || selector.type === "checkbox") {
          isSelected = selector.checked;
        } else if (selector.tagName === "SELECT") {
          isSelected = selector.selectedIndex >= 0;
        }

        if (isSelected) {
          var optionPosition =
            parseInt(selector.getAttribute("data-option-position")) || 1;
          var optionValue = selector.value;
          selectedOptions[optionPosition - 1] = optionValue;
        }
      }

      var matchingVariant = variants.find(function (variant) {
        for (var i = 0; i < selectedOptions.length; i++) {
          if (selectedOptions[i] === undefined || selectedOptions[i] === null) {
            continue;
          }
          var optionKey = "option" + (i + 1);
          if (variant[optionKey] !== selectedOptions[i]) {
            return false;
          }
        }

        var hasMatch = false;
        for (var i = 0; i < selectedOptions.length; i++) {
          if (selectedOptions[i] !== undefined && selectedOptions[i] !== null) {
            hasMatch = true;
            break;
          }
        }
        return hasMatch;
      });

      if (matchingVariant) {
        return matchingVariant;
      } else {
        return null;
      }
    } catch (e) {
      console.error(
        "[getVariantFromSelectedOptions] Error getting variant from options:",
        e
      );
      return null;
    }
  }

  function getCurrentVariantPrice() {
    var priceContainer = window.getPriceContainer();

    if (priceContainer) {
      var dataPrice = priceContainer.getAttribute("data-variant-price");

      if (dataPrice) {
        var parsed = parseInt(dataPrice);

        return parsed;
      }
    }

    try {
      var productJson = document.querySelector(
        '[type="application/json"][data-product-json]'
      )?.textContent;
      if (productJson) {
        var productData = JSON.parse(productJson);
        var variantIdInput = document.querySelector('[name="id"]');
        var variantId = variantIdInput ? variantIdInput.value : null;
        if (variantId) {
          var selectedVariant = productData.variants?.find(function (v) {
            return String(v.id) === String(variantId);
          });
          if (selectedVariant && selectedVariant.price) {
            return parseInt(selectedVariant.price);
          }
        }
      }
    } catch (e) {}

    var originalPrice = window.getOriginalPrice();

    return originalPrice;
  }

  function getDiscountPreferenceWithPriority() {
    try {
      var lockedPreference = localStorage.getItem(
        "cartLockedDiscountPreference"
      );
      if (lockedPreference) {
        var buttonNumber = parseInt(lockedPreference, 10);

        var buttonMapping = window.getButtonDiscountMapping();
        if (buttonMapping) {
          var discountTitle =
            buttonNumber === 1 ? buttonMapping.button1 : buttonMapping.button2;
          if (discountTitle === null || discountTitle === undefined) {
            console.log(
              "[getDiscountPreferenceWithPriority] Button " +
                buttonNumber +
                " has null discount in mapping, returning empty string"
            );
            return "";
          }
          if (discountTitle) {
            return discountTitle;
          }
        }
      }

      var assemblyPref = localStorage.getItem("assemblyPreference");
      if (assemblyPref) {
        var buttonNumber = parseInt(assemblyPref, 10);
        var buttonMapping = window.getButtonDiscountMapping();
        if (buttonMapping) {
          var discountTitle =
            buttonNumber === 1 ? buttonMapping.button1 : buttonMapping.button2;
          if (discountTitle === null || discountTitle === undefined) {
            console.log(
              "[getDiscountPreferenceWithPriority] Assembly preference button " +
                buttonNumber +
                " has null discount in mapping, returning empty string"
            );
            return "";
          }
          if (discountTitle) {
            return discountTitle;
          }
        }
      }

      var activeDiscountTitle = window.getDiscountPreference();
      if (activeDiscountTitle && activeDiscountTitle.trim() !== "") {
        return activeDiscountTitle.trim();
      }

      var pageDiscount = window.getActiveDiscountFromPage();
      if (pageDiscount) {
        return pageDiscount;
      }

      return "";
    } catch (e) {
      console.error(
        "[getDiscountPreferenceWithPriority] Error getting discount preference:",
        e
      );
      return window.getDiscountPreference() || "";
    }
  }

  function resetToOriginalPrice() {
    var variantPrice = window.getCurrentVariantPrice();
    if (variantPrice) {
      window.updatePrice(null, variantPrice);
      updateAppliedDiscount(null);
    }
  }

  function interceptShopifyPriceUpdate() {
    if (!isProductPage) {
      return;
    }
    var variantSelects = document.querySelector(".product-form__variants");
    if (!variantSelects) return;
  }

  function initializeInterception() {
    if (!isProductPage) {
      return;
    }
    var variantSelects = document.querySelector(".product-form__variants");
    if (variantSelects) {
      window.interceptShopifyPriceUpdate();
    } else {
      setTimeout(initializeInterception, 100);
    }
  }

  let miniCartOpenedByUs = false;
  let clickOutsideHandler = null;
  let escapeKeyHandler = null;

  function closeMiniCart() {
    const miniCart = document.querySelector("#mini-cart");
    const toggleMiniCart = document.querySelector(
      "[data-action='toggle-mini-cart']"
    );
    const headerIconState = document.querySelector(
      ".header__cart-icon.icon-state"
    );

    miniCart?.setAttribute("aria-hidden", "true");
    toggleMiniCart?.setAttribute("aria-expanded", "false");
    headerIconState?.setAttribute("aria-expanded", "false");
    document.body.classList.remove("no-mobile-scroll");

    if (clickOutsideHandler) {
      document.removeEventListener("click", clickOutsideHandler);
      clickOutsideHandler = null;
    }
    if (escapeKeyHandler) {
      document.removeEventListener("keyup", escapeKeyHandler);
      escapeKeyHandler = null;
    }
    miniCartOpenedByUs = false;

    document.dispatchEvent(new CustomEvent("cart-drawer:close"));
  }

  function openMiniCart() {
    const miniCart = document.querySelector("#mini-cart");
    const toggleMiniCart = document.querySelector(
      "[data-action='toggle-mini-cart']"
    );
    const headerIconState = document.querySelector(
      ".header__cart-icon.icon-state"
    );
    const header = document.querySelector(".header");

    if (!miniCart && !toggleMiniCart && !headerIconState) return;

    if (miniCart?.getAttribute("aria-hidden") === "false") {
      closeMiniCart();
      return;
    }

    miniCart?.setAttribute("aria-hidden", "false");
    toggleMiniCart?.setAttribute("aria-expanded", "true");
    headerIconState?.setAttribute("aria-expanded", "true");
    // NOTE: Removed no-mobile-scroll for cart drawer - it's a side drawer, not a modal
    // The drawer slides in from the side and users should still be able to scroll the page
    // document.body.classList.add("no-mobile-scroll");
    miniCartOpenedByUs = true;

    // Scroll to top so the cart drawer is visible
    window.scrollTo({ top: 0, behavior: 'smooth' });

    setTimeout(function () {
      clickOutsideHandler = function (event) {
        if (!miniCartOpenedByUs) return;

        const clickedInsideMiniCart =
          miniCart && miniCart.contains(event.target);
        const clickedInsideHeader = header && header.contains(event.target);

        if (!clickedInsideMiniCart && !clickedInsideHeader) {
          closeMiniCart();
        }
      };
      document.addEventListener("click", clickOutsideHandler);
    }, 0);

    escapeKeyHandler = function (event) {
      if (event.key === "Escape" && miniCartOpenedByUs) {
        closeMiniCart();
      }
    };
    document.addEventListener("keyup", escapeKeyHandler);

    recalculateMiniCartHeight();
    ensureMiniCartScrollable();

    document.dispatchEvent(new CustomEvent("cart-drawer:open"));
  }

  function updateBubbleCount(bubbleCount, debugMessage) {
    console.log("updateBubbleCount", bubbleCount, debugMessage);
    const bubbleCountElement = document.querySelector(".header__cart-count");
    if (!bubbleCountElement) return;
    bubbleCountElement.textContent = bubbleCount;
  }

  var recalculateHeightTimer = null;
  var recalculateHeightRAF = null;

  function recalculateMiniCartHeight() {
    if (recalculateHeightTimer) {
      clearTimeout(recalculateHeightTimer);
    }
    if (recalculateHeightRAF) {
      cancelAnimationFrame(recalculateHeightRAF);
    }

    recalculateHeightTimer = setTimeout(function () {
      recalculateHeightRAF = requestAnimationFrame(function () {
        recalculateMiniCartHeightInternal();
      });
    }, 16);
  }

  function recalculateMiniCartHeightInternal() {
    try {
      var miniCart = document.querySelector("#mini-cart");
      if (!miniCart) return;

      var lineItemList = miniCart.querySelector(".mini-cart__line-item-list");
      if (lineItemList) {
        lineItemList.style.overflowY = "auto";
      }
    } catch (e) {}
  }

  function ensureMiniCartScrollable() {
    try {
      var lineItemList = document.querySelector(".mini-cart__line-item-list");
      if (lineItemList) {
        lineItemList.style.overflowY = "auto";
      }
    } catch (e) {}
  }

  function updateMiniCartFromSections(
    sectionsData,
    { openDrawer = false, updateBubbleCount = false, cartData = null } = {}
  ) {
    if (isCartPage) {
      return;
    }
    console.log("updateMiniCartFromSections line:888");
    const sectionHTML =
      sectionsData?.sections?.["mini-cart"] || sectionsData?.["mini-cart"];

    if (!sectionHTML) {
      console.warn("Mini-cart section missing in response");
      return { ok: false, error: "no-mini-cart-in-response" };
    }

    const target =
      ["#mini-cart", "#shopify-section-mini-cart", '[data-section="mini-cart"]']
        .map((s) => document.querySelector(s))
        .find(Boolean) || null;

    if (!target) {
      console.warn("Mini-cart element not found in DOM");
      return { ok: false, error: "no-mini-cart-element" };
    }

    const temp = document.createElement("div");
    temp.innerHTML = sectionHTML;

    const newMiniCart =
      [
        "#mini-cart",
        "#shopify-section-mini-cart",
        '[data-section="mini-cart"]',
        "form",
      ]
        .map((s) => temp.querySelector(s))
        .find(Boolean) ||
      temp.firstElementChild ||
      null;

    if (!newMiniCart) {
      console.warn("No mini-cart node found in parsed HTML");
      return { ok: false, error: "parsed-html-empty" };
    }

    const oldLineItemList = target.querySelector(".mini-cart__line-item-list");
    const scrollPosition = oldLineItemList ? oldLineItemList.scrollTop : 0;

    const oldInner = target.querySelector(".mini-cart__inner");
    const newInner = newMiniCart.querySelector(".mini-cart__inner");

    if (oldInner && newInner) {
      oldInner.innerHTML = newInner.innerHTML;
    } else {
      target.innerHTML = newMiniCart.innerHTML;
    }

    const newLineItemList = target.querySelector(".mini-cart__line-item-list");
    if (newLineItemList) {
      if (scrollPosition > 0) {
        newLineItemList.scrollTop = scrollPosition;
      }
      ensureMiniCartScrollable();
    }

    recalculateMiniCartHeight();

    const newCount =
      newMiniCart.getAttribute("data-item-count") ||
      newMiniCart
        .querySelector("[data-item-count]")
        ?.getAttribute("data-item-count");

    if (newCount != null) {
      target.setAttribute("data-item-count", newCount);
    }

    document.dispatchEvent(new CustomEvent("cart:refresh"));

    if (updateBubbleCount) {
      window.updateBubbleCount(newCount, "line 966");
    }

    if (openDrawer) {
      openMiniCart();

      setTimeout(() => {
        document.dispatchEvent(new CustomEvent("cart-drawer:refresh"));
      }, 100);
    } else {
      setTimeout(() => {
        document.dispatchEvent(new CustomEvent("cart-drawer:refresh"));
      }, 100);
    }

    if (typeof window.applyCartDrawerDiscounts === "function") {
      setTimeout(() => {
        console.log(
          "[MINI-CART] Calling applyCartDrawerDiscounts after DOM update"
        );
        window.applyCartDrawerDiscounts();

        setTimeout(() => {
          if (typeof window.recomputeDrawerSubtotalFromDOM === "function") {
            window.recomputeDrawerSubtotalFromDOM();
          }
        }, 200);
      }, 300);
    } else {
      console.warn("[MINI-CART] applyCartDrawerDiscounts not available");
    }

    return { ok: true };
  }

  var cartInteractionSelectors = [
    "form.cart-recap button[name='checkout']",
    '.mini-cart__button-container button[name="checkout"]',
    ".mini-cart__button-container a.button.button--secondary",
    '[data-essential-upsell-element="add-to-cart-button"]',
    ".discount-pill-remove",
    ".quantity.cart-update",
    ".quantity-selector",
    ".remove.mini-cart__quantity-remove.link",
    ".remove.line-item__quantity-remove.link",
  ];

  var cartMutationObserver = null;

  window._cartInteractionLockCount =
    typeof window._cartInteractionLockCount === "number"
      ? window._cartInteractionLockCount
      : 0;
  window._cartInteractionLockSources = window._cartInteractionLockSources || [];

  function applyDisabledStateToElements() {
    cartInteractionSelectors.forEach(function (selector) {
      var elements = document.querySelectorAll(selector);
      elements.forEach(function (el) {
        if (!el.classList.contains("disabled")) {
          el.classList.add("disabled");
          el.setAttribute("data-was-interactive", "true");
        }
      });
    });
  }

  function removeDisabledStateFromElements() {
    cartInteractionSelectors.forEach(function (selector) {
      var elements = document.querySelectorAll(selector);
      elements.forEach(function (el) {
        el.classList.remove("disabled");
        el.removeAttribute("data-was-interactive");
      });
    });
    ensureMiniCartScrollable();
  }

  function startCartMutationObserver() {
    if (cartMutationObserver) return;

    var miniCart = document.querySelector("#mini-cart");
    if (!miniCart) return;

    cartMutationObserver = new MutationObserver(function (mutations) {
      if (window._cartInteractionLockCount <= 0) return;

      var shouldReapply = mutations.some(function (mutation) {
        return (
          mutation.type === "childList" &&
          (mutation.addedNodes.length > 0 || mutation.removedNodes.length > 0)
        );
      });

      if (shouldReapply) {
        applyDisabledStateToElements();
      }
    });

    cartMutationObserver.observe(miniCart, {
      childList: true,
      subtree: true,
    });
  }

  function stopCartMutationObserver() {
    if (cartMutationObserver) {
      cartMutationObserver.disconnect();
      cartMutationObserver = null;
    }
  }

  function disableCartInteractions(functionCalledFromLineX) {
    window._cartInteractionLockCount++;
    window._cartInteractionLockSources.push(functionCalledFromLineX);

    console.log(
      "[CART-INTERACTIONS] Disabled from:",
      functionCalledFromLineX,
      "| Lock count:",
      window._cartInteractionLockCount,
      "| Active locks:",
      window._cartInteractionLockSources.slice()
    );

    window._cartInteractionsDisabled = true;

    applyDisabledStateToElements();

    startCartMutationObserver();
  }

  function enableCartInteractions(functionCalledFromLineX) {
    var sourceIndex = window._cartInteractionLockSources.indexOf(
      functionCalledFromLineX
    );
    if (sourceIndex === -1) {
      var prefix = functionCalledFromLineX.split(" ")[0];
      for (var i = 0; i < window._cartInteractionLockSources.length; i++) {
        if (window._cartInteractionLockSources[i].indexOf(prefix) === 0) {
          sourceIndex = i;
          break;
        }
      }
    }

    if (sourceIndex !== -1) {
      window._cartInteractionLockSources.splice(sourceIndex, 1);
    }

    window._cartInteractionLockCount = Math.max(
      0,
      window._cartInteractionLockCount - 1
    );

    console.log(
      "[CART-INTERACTIONS] Enable requested from:",
      functionCalledFromLineX,
      "| Lock count:",
      window._cartInteractionLockCount,
      "| Remaining locks:",
      window._cartInteractionLockSources.slice()
    );

    if (window._cartInteractionLockCount <= 0) {
      console.log(
        "[CART-INTERACTIONS] All locks released - enabling interactions"
      );
      window._cartInteractionsDisabled = false;
      window._cartInteractionLockCount = 0;
      window._cartInteractionLockSources = [];

      stopCartMutationObserver();
      removeDisabledStateFromElements();
    }
  }

  function forceEnableCartInteractions(functionCalledFromLineX) {
    console.log(
      "[CART-INTERACTIONS] FORCE enabled from:",
      functionCalledFromLineX,
      "| Was lock count:",
      window._cartInteractionLockCount
    );

    window._cartInteractionLockCount = 0;
    window._cartInteractionLockSources = [];
    window._cartInteractionsDisabled = false;

    stopCartMutationObserver();
    removeDisabledStateFromElements();
  }

  function handleButton2NoDiscount(wrapper) {
    showOriginalPrice();

    if (wrapper) {
      var btn2 = wrapper.querySelector("#discount-button-2");
      if (btn2) {
        document.querySelectorAll(".discount-button").forEach(function (btn) {
          btn.classList.remove("active");
        });
        btn2.classList.add("active");
      }
    }

    try {
      localStorage.setItem("assemblyPreference", "2");
    } catch (e) {
      console.error("[handleButton2NoDiscount] Error saving preference:", e);
    }

    return true;
  }

  function hasUserRemovedDiscountGlobal() {
    try {
      return localStorage.getItem("userRemovedDiscountGlobal") === "true";
    } catch (e) {
      return false;
    }
  }

  function setUserRemovedDiscountGlobal() {
    try {
      localStorage.setItem("userRemovedDiscountGlobal", "true");
    } catch (e) {
      console.error("[DISCOUNT] Error setting userRemovedDiscountGlobal:", e);
    }
  }

  function clearUserRemovedDiscountGlobal() {
    try {
      localStorage.removeItem("userRemovedDiscountGlobal");
    } catch (e) {
      console.error("[DISCOUNT] Error clearing userRemovedDiscountGlobal:", e);
    }
  }

  function getLocalizedPropertyAndTitle(productTitle, variantTitle) {
    var propertyLabels = {
      en: "For",
      de: "Für",
      fr: "Pour",
      it: "Per",
    };

    var currentLocale = document.documentElement.lang || "en";
    var langCode = currentLocale.split("-")[0].toLowerCase();
    var propertyKey = propertyLabels[langCode] || propertyLabels.en;

    var sanitizedVariant =
      variantTitle && variantTitle.trim() !== "Default Title"
        ? variantTitle.replace(/(\s*-?\s*default title\s*)$/i, "").trim()
        : "";

    var combinedTitle = (productTitle || "").trim();
    if (sanitizedVariant) {
      combinedTitle = combinedTitle
        ? combinedTitle + " " + sanitizedVariant
        : sanitizedVariant;
    }

    return { propertyKey: propertyKey, combinedTitle: combinedTitle };
  }

  window.formatMoney = formatMoney;
  window.formatMoneyDrawer = formatMoneyDrawer;
  window.parseMoneyTextToCents = parseMoneyTextToCents;
  window.saveDiscountPreference = saveDiscountPreference;
  window.getDiscountPreference = getDiscountPreference;
  window.hasNoDiscountPreference = hasNoDiscountPreference;
  window.saveVariantDiscount = saveVariantDiscount;
  window.markVariantNoDiscount = markVariantNoDiscount;
  window.variantHasNoDiscount = variantHasNoDiscount;
  window.getVariantDiscount = getVariantDiscount;
  window.getVariantDiscountData = getVariantDiscountData;
  window.getAssemblyPreference = getAssemblyPreference;
  window.isAssemblyBySkyPergola = isAssemblyBySkyPergola;
  window.getButtonDiscountMapping = getButtonDiscountMapping;
  window.getDiscountTitleForButtonNumber = getDiscountTitleForButtonNumber;
  window.hasActiveDiscountForButton = hasActiveDiscountForButton;
  window.getCurrentButtonNumber = getCurrentButtonNumber;
  window.hasActiveDiscountForCurrentSelection =
    hasActiveDiscountForCurrentSelection;
  window.shouldApplyDiscount = shouldApplyDiscount;
  window.showOriginalPrice = showOriginalPrice;
  window.getDiscountForButton = getDiscountForButton;
  window.syncCartLocalStorage = syncCartLocalStorage;
  window.cleanuplocalStorageForRemovedItems =
    cleanuplocalStorageForRemovedItems;
  window.findDiscountByTitle = findDiscountByTitle;
  window.getActiveDiscountFromPage = getActiveDiscountFromPage;
  window.getPriceContainer = getPriceContainer;
  window.getOriginalPrice = getOriginalPrice;
  window.getVariantFromSelectedOptions = getVariantFromSelectedOptions;
  window.getCurrentVariantPrice = getCurrentVariantPrice;
  window.getDiscountPreferenceWithPriority = getDiscountPreferenceWithPriority;
  window.resetToOriginalPrice = resetToOriginalPrice;
  window.interceptShopifyPriceUpdate = interceptShopifyPriceUpdate;
  window.initializeInterception = initializeInterception;
  window.updateMiniCartFromSections = updateMiniCartFromSections;
  window.recalculateMiniCartHeight = recalculateMiniCartHeight;
  window.ensureMiniCartScrollable = ensureMiniCartScrollable;
  window.openMiniCart = openMiniCart;
  window.closeMiniCart = closeMiniCart;
  window.updateBubbleCount = updateBubbleCount;
  window.disableCartInteractions = disableCartInteractions;
  window.enableCartInteractions = enableCartInteractions;
  window.forceEnableCartInteractions = forceEnableCartInteractions;
  window.isThisCartPage = isThisCartPage;
  window.handleButton2NoDiscount = handleButton2NoDiscount;
  window.hasUserRemovedDiscountGlobal = hasUserRemovedDiscountGlobal;
  window.setUserRemovedDiscountGlobal = setUserRemovedDiscountGlobal;
  window.clearUserRemovedDiscountGlobal = clearUserRemovedDiscountGlobal;
  window.getLocalizedPropertyAndTitle = getLocalizedPropertyAndTitle;

  document.addEventListener("cart-drawer:refresh", function () {
    setTimeout(ensureMiniCartScrollable, 50);
  });
  document.addEventListener("cart-drawer:open", function () {
    setTimeout(ensureMiniCartScrollable, 100);
  });
  document.addEventListener("cart:refresh", function () {
    setTimeout(ensureMiniCartScrollable, 50);
  });
})();
